<template>
    <div class="overlay" v-if="display">
        <img :src="imagePath('./steps/loader_icon_3.png')">
        <img :src="imagePath('./steps/loader_icon_2.png')">
        <img :src="imagePath('./steps/loader_icon_1.png')">
    </div>
</template>

<script>
  export default {
    name: "loader",
    data: function(){
      return {
      }
    },

    computed: {
      display: function() {
        // wyświetla loader jeśli loading jest true
        return this.$store.state.loader.loading;
      }
    },

    methods: {
      imagePath: function(name){
        const images = require.context('images', true);
        return images(name, true);
      }
    }
  }
</script>

<style lang="scss" scoped>

    .overlay {
        //display: none;
        position: fixed;
        height: 100%;
        width: 100%;
        z-index: 100;
        top: 0;
        left: 0;
        background: rgba(100,100,100,0.9);
        &.redirect-overlay{
            position: relative;
            height: 500px;
        }

        & > * {
            position: absolute;
            margin: auto;
            left: 0;
            bottom: 0;
            right: 0;
        }

        @mixin rotate($x) {
            -webkit-transform: rotate($x);
            -moz-transform: rotate($x);
            -ms-transform: rotate($x);
            -o-transform: rotate($x);
            transform: rotate($x);
        }

        @keyframes spin-clockwise {
            80% {
                @include rotate(360deg);
            }
            80%, 100%{
                @include rotate(360deg);
            }
        }

        @keyframes spin-anticlockwise {
            80% {
                @include rotate(-360deg);
            }
            80%, 100% {
                @include rotate(-360deg);
            }
        }

        & > img {
            top: -50%;
        }

        & > img:nth-child(odd) {
            animation: spin-clockwise 3s linear infinite;
            //animation-delay: 2s;
        }

        & > img:nth-child(even) {
            animation: spin-anticlockwise 3s linear infinite;
            //animation-delay: 2s;
        }

    }

</style>